<template>
  <!-- Table Container Card -->
  <div>
    <div class="col-6 d-flex align-items-center justify-content-lg-start">
      <Button
        v-if="(showBackButton && actionType === 'save') || 'add'"
        :label="$t('List page')"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationAction"
      />
    </div>
    <form-wizard
      ref="individualCustomerForm"
      :title="null"
      :subtitle="null"
      layout="vertical"
      :back-button-text="$t('Previous')"
      :next-button-text="$t('Next')"
      class="wizard-vertical mb-3"
    >
      <!-- Personal Information tab -->
      <tab-content
        :title="$t('Personal Information')"
        :before-change="validatePersonal"
      >
        <validation-observer ref="personalInfoRules">
          <b-form>
            <b-row class="match-height">
              <b-col
                md="6"
              >
                <div class="d-flex validate-inline-field">
                  <InputField
                    id="bvn"
                    v-model="individualCustomerFormData.bvn"
                    :label="$t('BVN')"
                    :placeholder="$t('Enter BVN')"
                    type="number"
                    :error-name="$t('BVN')"
                    :rules="enforceKYCAtCustomerCreation ? 'required|integer|length:11' : 'integer|length:11'"
                    :is-allow-only-special-characters="false"
                    :max-length="10"
                    :on-input="setBVN"
                    :readonly="isBVN"
                    class="flex-grow-1 validation-field-input"
                  />
                  <Button
                    v-if="getUserPermission('VALIDATE_BVN')"
                    :label="$t('Validate')"
                    :loading="isLoading"
                    size="md"
                    class="validation-action-btn"
                    @click="bvnValidateAction"
                  />
                </div>
              </b-col>
              <b-col
                md="6"
              >
                <div class="d-flex validate-inline-field">
                  <InputField
                    id="nin"
                    v-model="individualCustomerFormData.nin"
                    :label="$t('NIN')"
                    :placeholder="$t('Enter NIN')"
                    type="text"
                    :error-name="$t('NIN')"
                    :rules="enforceKYCAtCustomerCreation ? 'required' : ''"
                    :is-allow-only-special-characters="false"
                    :readonly="isNIN"
                    class="flex-grow-1 validation-field-input"
                  />
                  <Button
                    v-if="getUserPermission('VALIDATE_NIN')"
                    :label="$t('Validate')"
                    :loading="isLoadingNIN"
                    size="md"
                    class="validation-action-btn"
                    @click="ninValidateAction"
                  />
                </div>
              </b-col>
              <b-col md="6">
                <SelectField
                  id="title"
                  v-model="individualCustomerFormData.title"
                  :label="$t('Title')"
                  :options="translatedTitleOptions"
                  :reduce="(option) => option.value"
                  :error-name="$t('Title')"
                  rules="required"
                  item="label"
                  placeholder="Select"
                />
              </b-col>

              <!-- Last Name -->
              <b-col md="6">
                <InputField
                  id="last-name"
                  v-model="individualCustomerFormData.lastName"
                  :label="$t('Last Name')"
                  :placeholder="$t('Enter last name')"
                  type="text"
                  :error-name="$t('Last Name')"
                  rules="required"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Last Name -->

              <!-- First Name -->
              <b-col md="6">
                <InputField
                  id="first-name"
                  v-model="individualCustomerFormData.firstName"
                  :label="$t('First Name')"
                  :placeholder="$t('Enter first name')"
                  type="text"
                  :error-name="$t('First Name')"
                  rules="required"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- First Name -->

              <!-- Other Name -->
              <b-col md="6">
                <InputField
                  id="other-names"
                  v-model="individualCustomerFormData.otherNames"
                  :label="$t('Other Names')"
                  :placeholder="$t('Enter other names')"
                  type="text"
                  :error-name="$t('Other Names')"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Other Name -->

              <!-- Maiden Name -->
              <b-col md="6">
                <InputField
                  id="maiden-name"
                  v-model="individualCustomerFormData.maidenName"
                  :label="$t('Maiden Name')"
                  :placeholder="$t('Enter maiden name')"
                  type="text"
                />
              </b-col>
              <!-- Maiden Name -->

              <!-- Gender -->
              <b-col md="6">
                <SelectField
                  id="gender1"
                  v-model="individualCustomerFormData.gender"
                  :label="$t('Gender')"
                  :options="genderOptions"
                  :reduce="(option) => option.value"
                  item="label"
                  :error-name="$t('Gender')"
                  rules="required"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!-- Gender -->
              <!-- Marital Status -->
              <b-col md="6">
                <SelectField
                  id="marital-status"
                  v-model="individualCustomerFormData.maritalStatus"
                  :label="$t('Marital Status')"
                  :options="translatedmaritalStatusOptions"
                  :reduce="(option) => option.value"
                  :error-name="$t('Marital Status')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!-- Marital Status -->

              <b-col md="6">
                <InputField
                  id="nin-user-id"
                  v-model="individualCustomerFormData.userID"
                  :label="$t('NIN User-ID')"
                  :placeholder="$t('Enter nin user Id')"
                  type="text"
                  rules="id-check"
                  :error-name="$t('NIN User-ID')"
                />
              </b-col>
            </b-row>
            <b-row>
              <!-- Phone Number -->
              <b-col md="6">
                <InputField
                  id="phone-number"
                  v-model="individualCustomerFormData.phoneNumber"
                  :label="$t('Phone Number')"
                  :placeholder="$t('Enter phone number')"
                  type="text"
                  :error-name="$t('Phone Number')"
                  rules="required|min:7|max:15"
                  :on-input="setPhoneNumber"
                />
              </b-col>
              <!-- Phone Number -->

              <!-- Secondary Phone Numbers -->
              <b-col md="6">
                <TextAreaField
                  id="sec-phone-number"
                  v-model="individualCustomerFormData.notificationPhoneNumber"
                  :label="$t('Notification Phone Number')"
                  :placeholder="
                    $t('For multiple Phone Numbers, separate by comma (,)')
                  "
                  type="text"
                  for="sec-phone-number"
                  :error-name="$t('Phone Number')"
                  rules="required"
                  rows="2"
                  show-icon
                  :on-click="onViewPhoneInfo"
                />
              </b-col>
              <!-- Secondary Phone Number -->

              <!-- Email -->
              <b-col md="6">
                <InputField
                  id="email"
                  v-model="individualCustomerFormData.email"
                  :label="$t('Email')"
                  :placeholder="$t('Enter email')"
                  type="email"
                  :on-input="setEmailAddress"
                />
              </b-col>
              <!--  Email -->

              <!-- Secondary Email -->
              <b-col md="6">
                <TextAreaField
                  id="sec-email"
                  v-model="individualCustomerFormData.notificationEmail"
                  :label="$t('Notification Email')"
                  :placeholder="
                    $t('For multiple Emails, separate by comma (,)')
                  "
                  type="text"
                  rows="2"
                  show-icon
                  :on-click="onViewEmailInfo"
                />
              </b-col>
              <!-- Secondary Email -->
            </b-row>
            <b-row>
              <!-- Date of Birth -->
              <b-col md="6">
                <DatePickerField
                  id="date-of-birth"
                  v-model="individualCustomerFormData.dateOfBirth"
                  rules="required"
                  :label="$t('Date of Birth')"
                  format="Y-m-d"
                  :error-name="$t('Date of Birth')"
                  :config="datePickerConfig"
                  :disabled="isReadonly"
                />
              </b-col>
              <!--  Date of Birth -->

              <!-- Country -->
              <b-col md="6">
                <SelectField
                  id="country"
                  v-model="individualCustomerFormData.nationality"
                  :label="$t('Country')"
                  :options="countryOptions"
                  :reduce="(option) => option"
                  :error-name="$t('Country')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  Country -->

              <!--  Nationality -->
              <!-- <b-col md="6">
              <SelectField
                id="nationality"
                v-model="individualCustomerFormData.nationality"
                label="Nationality"
                :options="nationalityOptions"
                :reduce="option => option"
                error-name="Nationality"
                rules="required"
                item="label"
                placeholder="Select"
              />
            </b-col> -->
              <!--  Nationality -->
              <!-- State -->
              <b-col md="6">
                <SelectField
                  id="state"
                  v-model="individualCustomerFormData.state"
                  :label="$t('State/Province')"
                  :options="stateOptions"
                  :reduce="(option) => option"
                  :error-name="$t('State')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                  :set-selected="getLGAByState"
                />
              </b-col>
              <!--  State -->

              <!-- LGA/Cities -->
              <b-col md="6">
                <SelectField
                  id="state"
                  v-model="individualCustomerFormData.lga"
                  :label="$t('LGA/Cities')"
                  :options="lgaOptions"
                  :reduce="(option) => option"
                  :error-name="$t('LGA')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  LGA -->

              <!-- Home Town -->
              <b-col md="6">
                <InputField
                  id="home-town"
                  v-model="individualCustomerFormData.hometown"
                  :label="$t('Home Town')"
                  :placeholder="$t('Enter home town')"
                  type="text"
                  :error-name="$t('Home Town')"
                  rules="required"
                />
              </b-col>
              <!-- Home Town -->

              <!-- Religion -->
              <b-col md="6">
                <SelectField
                  id="religion"
                  v-model="individualCustomerFormData.religion"
                  :label="$t('Religion')"
                  :options="translatedReligionOptions"
                  :reduce="(option) => option.value"
                  :error-name="$t('Religion')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  Religion -->

              <!-- Nationality -->
              <!-- <b-col md="6">
              <InputField
                id="nationality"
                v-model="individualCustomerFormData.nationality"
                label="Nationality"
                placeholder="Enter nationality"
                type="text"
                error-name="Nationality"
                rules="required"
                for="nationality"
              />
            </b-col> -->
              <!-- Nationality -->

              <!--  Means of Identification -->
              <b-col md="6">
                <SelectField
                  id="means-of-id"
                  v-model="individualCustomerFormData.meansOfIdentification"
                  :label="$t('Means of Identification')"
                  :options="translatedMeansOfIdOptions"
                  :reduce="(option) => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  Means of Identification -->

              <!-- Means of Identification Number -->
              <b-col md="6">
                <InputField
                  id="id-number"
                  v-model="individualCustomerFormData.idNumber"
                  :label="$t('Means of Identification Number')"
                  :placeholder="$t('Enter identification number on your card')"
                  type="text"
                />
              </b-col>
              <!-- Means of Identification Number -->

              <b-col md="6">
                <DatePickerField
                  id="issue-date"
                  v-model="
                    individualCustomerFormData.meansOfIdentificationIssueDate
                  "
                  :label="$t('Means of Identification Issue Date')"
                  format="Y-m-d"
                  :config="datePickerConfig"
                  :disabled="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <DatePickerField
                  id="expiry-date"
                  v-model="
                    individualCustomerFormData.meansOfIdentificationExpiryDate
                  "
                  :label="$t('Means of Identification Expiry Date')"
                  format="Y-m-d"
                  :config="datePickerConfig"
                  :disabled="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="issuing-authority"
                  v-model="
                    individualCustomerFormData.meansOfIdentificationPlaceOfIssue
                  "
                  :label="$t('Issuing Authority')"
                  :placeholder="$t('Enter Issuing Authority')"
                  type="text"
                />
              </b-col>
              <!--  PEP -->
              <b-col md="6">
                <SelectField
                  id="pep"
                  v-model="individualCustomerFormData.pep"
                  :label="$t('PEP')"
                  :options="translatedPepOptions"
                  :reduce="(option) => option.value"
                  :error-name="$t('PEP')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  PEP -->
              <!-- Tin -->
              <b-col md="6">
                <InputField
                  id="tin"
                  v-model="individualCustomerFormData.tin"
                  :label="$t('TIN')"
                  :placeholder="$t('Enter TIN')"
                  type="text"
                />
              </b-col>
              <!-- Tin -->

              <!--  Old customer ID -->
              <b-col md="6">
                <InputField
                  id="reference-number"
                  v-model="individualCustomerFormData.oldCustomerID"
                  :label="$t('Old customer ID')"
                  :placeholder="$t('Enter old customer ID')"
                  type="text"
                  show-icon
                  :on-click="onViewInfo"
                />
              </b-col>
              <!--  Old customer ID -->

              <!--  IPPIS/Oracle ID -->
              <b-col md="6">
                <InputField
                  id="ippis-oracle"
                  v-model="individualCustomerFormData.employeeID"
                  :label="$t('IPPIS/Oracle ID')"
                  :placeholder="$t('Enter IPPIS/Oracle ID')"
                  type="text"
                />
              </b-col>
              <!--  IPPIS/Oracle ID -->

              <!--  Address -->
              <b-col md="12">
                <TextAreaField
                  id="address"
                  v-model="individualCustomerFormData.address"
                  :label="$t('Address')"
                  :placeholder="$t('Enter address')"
                  :error-name="$t('Address')"
                  rules="required"
                  for="address"
                  rows="5"
                />
              </b-col>
            </b-row>
            <!--  Address -->
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Next of Kin Information tab -->
      <tab-content
        :title="$t('Next of Kin')"
        :before-change="validateNextOfKin"
      >
        <validation-observer ref="nextOfKinRules">
          <b-form>
            <b-row class="match-height">
              <!-- Name -->
              <b-col md="4">
                <InputField
                  id="name"
                  v-model="individualCustomerFormData.nokName"
                  :label="$t('Name')"
                  :placeholder="$t('Enter name')"
                  type="text"
                />
              </b-col>
              <!-- Name -->

              <!-- Email -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="email"
                    v-model="individualCustomerFormData.nokEmail"
                    :label="$t('Email')"
                    :placeholder="$t('Enter email')"
                    type="email"
                    :error-name="$t('Email')"
                    rules="email"
                  />
                </b-form-group>
              </b-col>
              <!--  Email -->

              <!-- Phone Number -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="phone-number"
                    v-model="individualCustomerFormData.nokPhoneNumber"
                    :label="$t('Phone Number')"
                    :placeholder="$t('Enter phone number')"
                    type="number"
                    :error-name="$t('Phone Number')"
                    rules="integer|min:7|max:11"
                  />
                </b-form-group>
              </b-col>
              <!-- Phone Number -->
            </b-row>

            <b-row class="match-height">
              <!-- Relationship -->
              <b-col md="4">
                <b-form-group>
                  <SelectField
                    id="gender"
                    v-model="individualCustomerFormData.nokRelationship"
                    :label="$t('Relationship')"
                    :options="translatedRelationshipOptions"
                    :reduce="(option) => option.value"
                    item="label"
                    :placeholder="$t('Select')"
                    :set-selected="setRelationship"
                  />
                </b-form-group>
              </b-col>
              <!-- Relationship -->

              <!-- Others -->
              <b-col
                v-if="isOtherTypeOfRelationship"
                md="4"
              >
                <b-form-group>
                  <InputField
                    id="phone-number"
                    v-model="typeOfRelationship"
                    :label="$t('Others')"
                    :placeholder="$t('Enter relationship')"
                    type="text"
                    :error-name="$t('Relationship')"
                    rules="required"
                  />
                </b-form-group>
              </b-col>
              <!-- Others -->

              <!--Gender -->
              <b-col md="4">
                <SelectField
                  id="gender"
                  v-model="individualCustomerFormData.nokGender"
                  :label="$t('Gender')"
                  :options="genderOptions"
                  :reduce="(option) => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!-- Gender -->
            </b-row>

            <!--  Address -->
            <b-row class="match-height">
              <b-col md="12">
                <TextAreaField
                  id="next-of-kin-address"
                  v-model="individualCustomerFormData.nokAddress"
                  :label="$t('Address')"
                  :placeholder="$t('Enter address')"
                  rows="5"
                />
              </b-col>
            </b-row>
            <!--  Address -->
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Work Information tab-->
      <tab-content
        :title="$t('Work Information')"
        :before-change="validateWorkInfo"
      >
        <validation-observer ref="workInfoRules">
          <b-form>
            <b-row class="match-height">
              <!-- Occupation -->
              <b-col md="4">
                <InputField
                  id="occupation"
                  v-model="individualCustomerFormData.occupation"
                  :label="$t('Occupation')"
                  :placeholder="$t('Enter occupation')"
                  type="text"
                />
              </b-col>
              <!-- Occupation -->

              <!-- Employer's Name -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="employer-name"
                    v-model="individualCustomerFormData.employerName"
                    :label="$t('Employer\'s Name')"
                    :placeholder="$t('Enter employer\'s name')"
                    type="text"
                    :error-name="$t('Employer\'s Name')"
                  />
                </b-form-group>
              </b-col>
              <!--  Email -->

              <!-- Phone Number -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="phone-number"
                    v-model="individualCustomerFormData.officePhoneNumber"
                    :label="$t('Phone Number')"
                    :placeholder="$t('Enter phone number')"
                    type="number"
                    :error-name="$t('Phone Number')"
                    rules="integer|min:7|max:11"
                  />
                </b-form-group>
              </b-col>
              <!-- Phone Number -->
            </b-row>

            <!--  Address -->
            <b-row class="match-height">
              <b-col md="12">
                <TextAreaField
                  id="employer-address"
                  v-model="individualCustomerFormData.employerAddress"
                  :label="$t('Employer\'s Address')"
                  :placeholder="$t('Enter employer\'s address')"
                  rows="5"
                />
              </b-col>
            </b-row>
            <!--  Address -->
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Other Documents tab-->
      <tab-content
        :title="$t('Other Documents')"
        :before-change="validatUploads"
      >
        <validation-observer ref="uploadRules">
          <b-form>
            <div>
              <div class="w-full mt-4 p-10">
                <div
                  class="d-flex mb-0 mt-2 align-items-center justify-content-between"
                >
                  <h4>{{ $t("Other Documents Upload") }}</h4>

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="ml-4"
                    @click="addNewDocument()"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                    />
                    <span>{{ $t("Add New Document") }}</span>
                  </b-button>
                </div>
                <b-row
                  v-for="(item, index) in documentsFormData"
                  :id="index"
                  :key="index"
                  class="mb-2"
                >
                  <b-col md="6">
                    <SelectField
                      id="document-type"
                      v-model="item.type"
                      :reduce="(option) => option.value"
                      :label="$t('Document Type')"
                      :placeholder="$t('Select')"
                      :options="translatedDocumentTypeOptions"
                      :error-name="$t('Document Type')"
                      rules="required"
                      item="label"
                    />
                  </b-col>
                  <b-col md="7">
                    <label> {{ $t("Upload Documents") }}</label>

                    <div class="upload-image">
                      <Spinner :show="documentLoadSpinner" />
                      <b-form-group>
                        <b-form-file
                          :placeholder="$t('Choose a file or drop it here...')"
                          :drop-placeholder="$t('Drop file here...')"
                          accept="image/jpeg, image/bmp, image/png, image/jpg, application/pdf, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          plain
                          @change="onDocumentsUpload(index, $event)"
                        />
                        <div
                          v-if="!item.url"
                          class="upload-instruction"
                        >
                          <h4>{{ $t("Upload Document File") }}</h4>
                          <p>
                            {{
                              $t(
                                "Drag & drop file or choose from your device to upload"
                              )
                            }}
                          </p>
                          <p class="format">
                            {{
                              $t(
                                "Format accepted (jpg, png, bmp, jpeg, docx, pdf)"
                              )
                            }}
                          </p>
                        </div>
                        <div v-else>
                          <div
                            v-if="
                              item.fileExtension === 'png' ||
                                item.fileExtension === 'jpeg' ||
                                item.fileExtension === 'jpg' ||
                                item.fileExtension === 'bmp'
                            "
                          >
                            <b-img
                              :src="item.url"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div v-if="item.fileExtension === 'pdf'">
                            <b-img
                              :src="pdfIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div v-else-if="item.fileExtension === 'vnd'">
                            <b-img
                              :src="wordIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div v-else>
                            <b-img src="" />
                          </div>
                          <div
                            v-if="item.url"
                            class="trash"
                          >
                            <feather-icon
                              icon="Trash2Icon"
                              size="20"
                              class="text-primary"
                              @click="deleteDocumentFile(item.id, index)"
                            />
                          </div>
                          <div
                            v-if="item.url"
                            class="view-details"
                          >
                            <feather-icon
                              icon="EyeIcon"
                              size="20"
                              class="text-primary"
                              @click="
                                viewDocumentFile(
                                  item.url,
                                  item.fileName,
                                  item.fileExtension
                                )
                              "
                            />
                          </div>
                          <!-- </div> -->
                        </div>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col
                    md="3"
                    class="mt-0"
                  >
                    <b-row>
                      <!-- Remove Button -->
                      <b-col
                        v-if="item.url"
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="removeDocument(item.id, index)"
                        >
                          <feather-icon
                            icon="XIcon"
                            class="mr-25"
                          />
                          <span>{{ $t("Remove") }}</span>
                        </b-button>
                      </b-col>
                      <b-col
                        v-if="item.url"
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="handleDownload(item.url)"
                        >
                          <feather-icon
                            icon="DownloadIcon"
                            class="mr-25"
                          />
                          <span>{{ $t("Download") }}</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </tab-content>

      <template slot="finish">
        <div class="wizard-footer-right">
          <Button
            :label="$t('Submit')"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>
      </template>

      <b-modal
        id="info-modal"
        ref="infoModal"
        centered
        size="md"
        ok-only
        :ok-title="$t('Okay')"
        @ok="hideModal('info-modal')"
      >
        <div class="p-2">
          <p>{{ $t("External Customer Reference") }}</p>
        </div>
      </b-modal>
      <b-modal
        id="info-email-modal"
        ref="infoEmailModal"
        centered
        size="md"
        ok-only
        :ok-title="$t('Okay')"
        @ok="hideModal('info-email-modal')"
      >
        <div class="p-2">
          <p>{{ $t("For multiple Email Addresses, separate by comma (,)") }}</p>
        </div>
      </b-modal>
      <b-modal
        id="info-phone-modal"
        ref="infoPhoneModal"
        centered
        size="md"
        ok-only
        :ok-title="$t('Okay')"
        @ok="hideModal('info-phone-modal')"
      >
        <div class="p-2">
          <p>{{ $t("For multiple Phone Numbers, separate by comma (,)") }}</p>
        </div>
      </b-modal>
      <b-modal
        id="view-avatar-modal"
        ref="avatarModal"
        no-close-on-backdrop
        :ok-title="$t('Download File')"
        :cancel-title="$t('Cancel')"
        cancel-variant="outline-secondary"
        centered
        size="lg"
        :title="viewDocumentModalTitle"
        @hidden="resetDocumentModal"
        @cancel="resetDocumentModal"
        @ok="handleDownload(viewDocumentData)"
      >
        <div class="m-2 text-center">
          <b-row>
            <b-col cols="12">
              <div
                v-if="
                  fileExtension === 'png' ||
                    fileExtension === 'jpeg' ||
                    fileExtension === 'jpg'
                "
              >
                <b-img
                  :src="viewDocumentData"
                  block
                  fluid
                  rounded
                />
              </div>
              <div v-else-if="fileExtension === 'pdf'">
                <b-img
                  :src="pdfIcon"
                  block
                  width="250px"
                  height="250px"
                  rounded
                />
              </div>
              <div v-else-if="fileExtension === 'vnd'">
                <b-img
                  :src="wordIcon"
                  block
                  width="250px"
                  height="250px"
                  rounded
                />
              </div>
              <div v-else>
                <b-img src="" />
              </div>
            </b-col>
          </b-row>
        </div>
      </b-modal>

      <b-modal
        id="bvn-validation-modal"
        ref="bvnModal"
        no-close-on-backdrop
        :ok-title="$t('Continue')"
        :cancel-title="$t('Cancel')"
        cancel-variant="outline-secondary"
        centered
        size="lg"
        :title="$t('BVN Validation')"
        @ok="handleContinue(viewDocumentData)"
      >
        <div class="m-2">
          <b-img
            class="mt-1 mb-2"
            :src="bvnInformationDetails.base64Image"
            block
            rounded
            width="150px"
          />
          <b-row>
            <b-col md="4">
              <InputField
                id="bvn"
                v-model="bvnInformationDetails.bvn"
                :label="$t('BVN')"
                :placeholder="$t('BVN')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="title"
                v-model="bvnInformationDetails.title"
                :label="$t('Title')"
                :placeholder="$t('Title')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="first-name"
                v-model="bvnInformationDetails.firstName"
                :label="$t('First Name')"
                :placeholder="$t('First Name')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="last-name"
                v-model="bvnInformationDetails.lastName"
                :label="$t('Last Name')"
                :placeholder="$t('Last Name')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="middle-names"
                v-model="bvnInformationDetails.middleName"
                :label="$t('Other Name')"
                :placeholder="$t('Other Name')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="date-of-birth"
                v-model="bvnInformationDetails.dateOfBirth"
                :label="$t('Date Of Birth')"
                :placeholder="$t('Date Of Birth')"
                type="text"
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="marital-status"
                v-model="bvnInformationDetails.maritalStatus"
                :label="$t('Marital Status')"
                :placeholder="$t('Marital Status')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="email"
                v-model="bvnInformationDetails.email"
                :label="$t('Email')"
                :placeholder="$t('Email')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="gender"
                v-model="bvnInformationDetails.gender"
                :label="$t('Gender')"
                :placeholder="$t('Gender')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="phone-number"
                v-model="bvnInformationDetails.phoneNumber1"
                :label="$t('Phone Number')"
                :placeholder="$t('Phone Number')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="nin"
                v-model="bvnInformationDetails.nin"
                :label="$t('NIN')"
                :placeholder="$t('NIN')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="nationality"
                v-model="bvnInformationDetails.nationality"
                :label="$t('Nationality')"
                :placeholder="$t('Nationality')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="state-of-origin"
                v-model="bvnInformationDetails.stateOfOrigin"
                :label="$t('State Of Origin')"
                :placeholder="$t('State Of Origin')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="state-of-residence"
                v-model="bvnInformationDetails.stateOfResidence"
                :label="$t('State Of Residence')"
                :placeholder="$t('State Of Residence')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="lga-of-origin"
                v-model="bvnInformationDetails.lgaOfOrigin"
                :label="$t('LGA Of Origin')"
                :placeholder="$t('LGA Of Origin')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="lga-of-residence"
                v-model="bvnInformationDetails.lgaOfResidence"
                :label="$t('LGA Of Residence')"
                :placeholder="$t('LGA Of Residence')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="registration-date"
                v-model="bvnInformationDetails.registrationDate"
                :label="$t('Registration Date')"
                :placeholder="$t('Registration Date')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="enrollment-bank"
                v-model="bvnInformationDetails.enrollmentBank"
                :label="$t('Enrollment Bank')"
                :placeholder="$t('Enrollment Bank')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="enrollment-branch"
                v-model="bvnInformationDetails.enrollmentBranch"
                :label="$t('Enrollment Branch')"
                :placeholder="$t('Enrollment Branch')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="level-of-account"
                v-model="bvnInformationDetails.levelOfAccount"
                :label="$t('Level Of Account')"
                :placeholder="$t('Level Of Account')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="12">
              <TextAreaField
                id="residential-address"
                v-model="bvnInformationDetails.residentialAddress"
                :label="$t('Residential Address')"
                :placeholder="$t('Residential Address')"
                type="text"
                rows="3"
                readonly
              />
            </b-col>
          </b-row>
        </div>
      </b-modal>

      <b-modal
        id="nin-validation-modal"
        ref="ninModal"
        no-close-on-backdrop
        :ok-title="$t('Continue')"
        :cancel-title="$t('Cancel')"
        cancel-variant="outline-secondary"
        centered
        size="lg"
        :title="$t('NIN Validation')"
        @ok="handleNINContinue(viewDocumentData)"
      >
        <div class="m-2">
          <b-img
            class="mt-1 mb-2"
            :src="`data:image/gif;base64,${ninInformationDetails.photo}`"
            block
            rounded
            width="150px"
          />
          <b-row>
            <b-col md="4">
              <InputField
                id="nin"
                v-model="ninInformationDetails.nin"
                :label="$t('NIN')"
                :placeholder="$t('NIN')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="nin-user-id"
                v-model="ninInformationDetails.userID"
                :label="$t('NIN User-ID')"
                :placeholder="$t('NIN User-ID')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="title"
                v-model="ninInformationDetails.title"
                :label="$t('Title')"
                :placeholder="$t('Title')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="first-name"
                v-model="ninInformationDetails.firstname"
                :label="$t('First Name')"
                :placeholder="$t('First Name')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="last-name"
                v-model="ninInformationDetails.surname"
                :label="$t('Last Name')"
                :placeholder="$t('Last Name')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="middle-names"
                v-model="ninInformationDetails.middlename"
                :label="$t('Other Name')"
                :placeholder="$t('Other Name')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="date-of-birth"
                v-model="ninInformationDetails.birthdate"
                :label="$t('Date Of Birth')"
                :placeholder="$t('Date Of Birth')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="marital-status"
                v-model="ninInformationDetails.maritalstatus"
                :label="$t('Marital Status')"
                :placeholder="$t('Marital Status')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="email"
                v-model="ninInformationDetails.email"
                :label="$t('Email')"
                :placeholder="$t('Email')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="gender"
                v-model="ninInformationDetails.gender"
                :label="$t('Gender')"
                :placeholder="$t('Gender')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="phone-number"
                v-model="ninInformationDetails.telephoneno"
                :label="$t('Phone Number')"
                :placeholder="$t('Phone Number')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="nationality"
                v-model="ninInformationDetails.birthcountry"
                :label="$t('Nationality')"
                :placeholder="$t('Nationality')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="state-of-origin"
                v-model="ninInformationDetails.birthstate"
                :label="$t('State Of Origin')"
                :placeholder="$t('State Of Origin')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="state-of-residence"
                v-model="ninInformationDetails.residence_state"
                :label="$t('State Of Residence')"
                :placeholder="$t('State Of Residence')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="lga-of-origin"
                v-model="ninInformationDetails.birthlga"
                :label="$t('LGA Of Origin')"
                :placeholder="$t('LGA Of Origin')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="lga-of-residence"
                v-model="ninInformationDetails.residence_lga"
                :label="$t('LGA Of Residence')"
                :placeholder="$t('LGA Of Residence')"
                type="text"
                readonly
              />
            </b-col>

            <b-col md="4">
              <InputField
                id="religion"
                v-model="ninInformationDetails.religion"
                :label="$t('Religion')"
                :placeholder="$t('Religion')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="nok-surname"
                v-model="ninInformationDetails.nok_surname"
                :label="$t('NOK Surname')"
                :placeholder="$t('NOK Surname')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="nok-firstname"
                v-model="ninInformationDetails.nok_firstname"
                :label="$t('NOK Firstname')"
                :placeholder="$t('NOK Firstname')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="nok-middlename"
                v-model="ninInformationDetails.nok_middlename"
                :label="$t('NOK Middlename')"
                :placeholder="$t('NOK Middlename')"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="12">
              <TextAreaField
                id="nok-middlename"
                v-model="ninInformationDetails.nok_address1"
                :label="$t('NOK Middlename')"
                placeholder="$t('NOK Middlename')"
                type="text"
                rows="3"
                readonly
              />
            </b-col>
            <b-col md="12">
              <TextAreaField
                id="residential-address"
                v-model="ninInformationDetails.residence_address"
                :label="$t('Residential Address')"
                :placeholder="$t('Residential Address')"
                type="text"
                rows="3"
                readonly
              />
            </b-col>
          </b-row>
        </div>
      </b-modal>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BButton,
  BFormGroup,
  BFormFile,
  BImg,
  VBTooltip,
  BForm,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required, minPhoneVal, maxPhoneVal } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import Ripple from 'vue-ripple-directive'
import { permissionMixin } from '@core/mixins/permission'
// import NationalityList from 'npm-nationality-list'
import { mapActions, mapGetters } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Spinner from '@/views/components/spinner/Spinner.vue'
import InputField from '../../../../forms/InputField.vue'
import TextAreaField from '../../../../forms/TextAreaField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  gender,
  pdfIcon,
  wordIcon,
  titleOptions,
  countries,
  religionOptions,
  meansOfIdOptions,
  maritalStatusOptions,
  relationshipOptions,
} from '../../../../../helpers/data'
import Button from '../../../../components/button/Button.vue'
import {
  toDateWithYear,
  toYearWithDate,
  dateSpecial,
} from '../../../../../helpers/formatDate'
import { accountPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BButton,
    BFormFile,
    SelectField,
    BImg,
    BFormGroup,
    FormWizard,
    TabContent,
    BForm,
    ValidationObserver,
    InputField,
    TextAreaField,
    DatePickerField,
    Button,
    Spinner,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      documentsFormData: [
        {
          type: '',
          url: '',
          file: '',
        },
      ],
      dateSpecial,
      viewDocumentData: '',
      viewDocumentModalTitle: '',
      fileExtension: '',
      documentLoadSpinner: false,
      documentTypeOptions: [
        { value: 1, label: 'Signature Specimen' },
        { value: 2, label: 'Proof Of Address' },
        { value: 3, label: 'Driver’s License' },
        { value: 4, label: 'National Identity Card' },
        { value: 5, label: 'Voters Card' },
        { value: 6, label: 'National Identity Number' },
        { value: 7, label: 'International Passport' },
        { value: 8, label: 'Passport Photograph' },
        { value: 9, label: 'Reference Letter' },
        { value: 10, label: 'Guarantor’s Letter' },
        { value: 11, label: 'Loan Application Form' },
        { value: 12, label: 'Credit Bureau Form' },
        { value: 13, label: 'Others' },
      ],
      documentIdentifier: '',

      typeOfRelationship: '',
      // genderOptions: gender,
      isOtherTypeOfRelationship: false,
      actionType: 'save',
      country: '',
      isDisabled: false,
      isLoading: false,
      isLoadingNIN: false,
      showBackButton: false,
      showSpinner: false,
      minPhoneVal,
      maxPhoneVal,
      required,
      sortDesc: false,
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        ariaDateFormat: 'd/m/Y',
      },
      tableHeaders: [
        { key: 'chargeName', sortable: true, label: 'Charge Name' },
        { key: 'amount1', sortable: true, label: 'Amount 1' },
        { key: 'amount2', sortable: true, label: 'Amount 2' },
        {
          key: 'consolidatedCharge',
          sortable: true,
          label: 'Consolidated Charge',
        },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'actions', label: 'Actions' },
      ],
      pdfIcon,
      wordIcon,
      // titleOptions,
      // religionOptions,
      // meansOfIdOptions,
      customerTypeOptions: [
        { label: 'Group', value: 1 },
        { label: 'Organisation', value: 2 },
      ],
      // maritalStatusOptions,
      pepOptions: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      // relationshipOptions,
      bvnInformationDetails: {},
      ninInformationDetails: {},
      individualCustomerFormData: {
        id: '',
        title: '',
        lastName: '',
        firstName: '',
        otherNames: '',
        address: '',
        gender: '',
        maritalStatus: '',
        maidenName: '',
        userID: '',
        religion: '',
        customerId: '',
        phoneNumber: '',
        notificationPhoneNumber: '',
        email: '',
        notificationEmail: '',
        hometown: '',
        dateOfBirth: '',
        nationality: '',
        state: '',
        lga: '',
        bvn: '',
        meansOfIdentification: '',
        idNumber: '',
        meansOfIdentificationIssueDate: null,
        meansOfIdentificationExpiryDate: null,
        meansOfIdentificationPlaceOfIssue: '',
        nokName: '',
        nokAddress: '',
        nokGender: '',
        nokRelationship: '',
        nokPhoneNumber: '',
        nokEmail: '',
        occupation: '',
        employerName: '',
        employerAddress: '',
        officePhoneNumber: '',
        pep: '',
        tin: '',
        oldCustomerID: '',
        employeeID: '',
        // secondaryPhoneNumber: '',
        // secondaryEmail: '',
      },
      countryCode: '',
      lgaOptions: [],
      nationalityOptions: [],
      signature: '',
      passport: '',
      isBVN: false,
      isNIN: false,
      enforceKYCAtCustomerCreation: false,
    }
  },
  computed: {
    ...mapGetters({
      token: 'auth/getToken',
    }),
    countryOptions() {
      return countries.map(item => item.name).sort()
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.key,
      }))
    },
    translatedDocumentTypeOptions() {
      return this.documentTypeOptions.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.value,
      }))
    },
    genderOptions() {
      return gender.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.value,
      }))
    },
    stateOptions() {
      if (this.individualCustomerFormData.nationality) {
        const country = countries.find(
          item => item.name === this.individualCustomerFormData.nationality,
        )
        return country?.states ? country?.states.map(item => item.state).sort() : []
      }
      return []
    },
    translatedmaritalStatusOptions() {
      return maritalStatusOptions.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.value,
      }))
    },
    translatedPepOptions() {
      return this.pepOptions.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.value,
      }))
    },
    translatedMeansOfIdOptions() {
      return meansOfIdOptions.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.value,
      }))
    },
    translatedReligionOptions() {
      return religionOptions.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.value,
      }))
    },
    translatedRelationshipOptions() {
      return relationshipOptions.map(header => ({
        ...header,
        label: header.label ? this.$t(header.label) : header.value,
      }))
    },
    translatedTitleOptions() {
      return titleOptions.map(item => ({
        label: this.$t(item.label),
        value: item.value,
      }))
    },
  },

  mounted() {
    // this.getNationalities()
    // this.getCountries()
    this.fetchEnforceKYCStatus()
    this.fetchIndividualCustomerDetails()
  },
  methods: {
    ...mapActions({
      getIndividualCustomer: 'account/getCustomer',
      createIndividualCustomer: 'account/createIndividualCustomerAction',
      updateIndividualCustomer: 'account/updateIndividualCustomerAction',
      uploadDocumentImages: 'account/uploadDocumentImagesAction',
      deleteDocumentsUpload: 'account/deleteDocumentsUploadAction',
      validateBVN: 'eChannels/validateBVNAction',
      validateNIN: 'eChannels/validateNINAction',
      getEnforceKYCStatus: 'operations/getOtherConfigurationList',
    }),

    addNewDocument() {
      this.documentsFormData.push({
        type: '',
        url: '',
        file: '',
      })
    },
    viewDocumentFile(image, title, fileExtension) {
      this.fileExtension = fileExtension
      this.viewDocumentData = image
      this.viewDocumentModalTitle = title.replace(
        /([a-zA-Z])(?=[A-Z])/g,
        '$1 ',
      )
      this.$root.$emit('bv::show::modal', 'view-avatar-modal')
    },
    resetDocumentModal() {
      this.viewDocumentData = ''
      this.viewDocumentModalTitle = ''
    },
    onViewEmailInfo() {
      this.$root.$emit('bv::show::modal', 'info-email-modal')
    },
    onViewPhoneInfo() {
      this.$root.$emit('bv::show::modal', 'info-phone-modal')
    },
    setPhoneNumber(val) {
      this.individualCustomerFormData.phoneNumber = val
      this.individualCustomerFormData.notificationPhoneNumber = this.individualCustomerFormData.phoneNumber
    },
    setBVN(val) {
      const sanitizedBVN = String(val || '').replace(/\D/g, '').slice(0, 10)
      this.individualCustomerFormData.bvn = sanitizedBVN
    },
    setEmailAddress(val) {
      this.individualCustomerFormData.email = val
      this.individualCustomerFormData.notificationEmail = this.individualCustomerFormData.email
    },
    handleDownload(data) {
      const link = document.createElement('a')
      link.href = data
      link.click()
      this.alertSuccess({
        text: this.$t('Your request to download file was successful'),
      })
    },
    async removeDocument(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({
          formData,
          permission: accountPermissions.VIEW_INDIVIDUAL_CUSTOMER,
        })
        const { status } = response
        if (status === 200) {
          this.documentLoadSpinner = false
          this.documentsFormData.splice(index, 1)
          this.alertSuccess({ text: this.$t('Document Removed') })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const deleteFailed = this.$t('Delete failed, Reason:')
          this.alertError({
            text: `${deleteFailed} ${responseError.errorMessage}`,
          })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    async deleteDocumentFile(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({
          formData,
          permission: accountPermissions.VIEW_INDIVIDUAL_CUSTOMER,
        })
        const { status } = response
        if (status === 200) {
          this.documentsFormData[index].url = ''
          this.documentLoadSpinner = false
          this.alertSuccess({ text: this.$t('Document Deleted') })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const deleteFailed = this.$t('Delete failed, Reason:')
          this.alertError({
            text: `${deleteFailed} ${responseError.errorMessage}`,
          })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },

    async onDocumentsUpload(index, event) {
      try {
        this.documentLoadSpinner = true
        const { files } = event.target

        const formData = new FormData()
        formData.append('attachedFile', files[0])
        formData.append('type', this.documentsFormData[index].type)
        formData.append('referenceNumber', this.documentIdentifier)
        const response = await this.uploadDocumentImages({
          formData,
          permission: accountPermissions.VIEW_INDIVIDUAL_CUSTOMER,
        })
        const { status, data } = await response
        if (status === 200 && data) {
          this.documentsFormData[index].url = data.url
          this.documentsFormData[index].id = data.id
          this.documentsFormData[index].fileExtension = data.fileExtension
          this.documentLoadSpinner = false
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const imageFailed = this.$t(
            'Your request to upload image failed. Reason:',
          )
          this.alertError({
            text: `${imageFailed} ${responseError.errorMessage}`,
          })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    onViewInfo() {
      this.$root.$emit('bv::show::modal', 'info-modal')
    },
    async fetchEnforceKYCStatus() {
      try {
        const response = await this.getEnforceKYCStatus({ permission: accountPermissions.VIEW_INDIVIDUAL_CUSTOMER })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.enforceKYCAtCustomerCreation = data.data.enforceKYCAtCustomerCreation
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    getLGAByState(selectedValue) {
      // this.individualCustomerFormData.lga = ''
      const country = countries.find(
        item => item.name === this.individualCustomerFormData.nationality,
      )
      const selectedState = country.states.find(
        item => item.state === selectedValue,
      )
      this.lgaOptions = selectedState.lgas.sort()
    },
    // getStateByCountry(selectedValue) {
    //   // this.individualCustomerFormData.state = ''
    //   if (this.individualCustomerFormData.nationality) {
    //     const country = countries.find(
    //       item => item.name === selectedValue,
    //     )
    //     this.stateOptions = country.states.map(item => item.state).sort()
    //   }
    //   this.stateOptions = []
    // },
    validatePersonal() {
      return new Promise((resolve, reject) => {
        this.$refs.personalInfoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    setRelationship(selectedValue) {
      if (selectedValue === 'Others') {
        this.isOtherTypeOfRelationship = true
      } else {
        this.isOtherTypeOfRelationship = false
        this.typeOfRelationship = ''
      }
    },
    // getNationalities() {
    //   const nationalities = NationalityList.getList()
    //   this.nationalityOptions = nationalities.reduce((acc, curr) => [...acc, curr.en_short_name], [])
    // },
    handleSubmit() {
      const action = `${
        this.actionType === 'save' ? this.$t('Save') : this.$t('Modify')
      }`
      const areYouSureText = this.$t('Are you sure you want to')
      const thisInfoText = this.$t('this Customer Information')
      this.confirm(this.individualInformationAction, {
        text: `${areYouSureText} ${action} ${thisInfoText}?`,
      })
    },
    async individualInformationAction() {
      const action = `${
        this.actionType === 'save' ? this.$t('Save') : this.$t('Modify')
      }`
      try {
        this.isLoading = true
        this.isDisabled = true
        this.showBackButton = true
        const nokRelationship = this.typeOfRelationship !== ''
          ? this.typeOfRelationship
          : this.individualCustomerFormData.nokRelationship
        const formData = {
          ...this.individualCustomerFormData,
          documentIdentifier: this.documentIdentifier,
          nokRelationship,
          dateOfBirth: toYearWithDate(
            this.individualCustomerFormData.dateOfBirth,
          ),
          meansOfIdentificationIssueDate: this.individualCustomerFormData
            .meansOfIdentificationIssueDate
            ? toYearWithDate(
              this.individualCustomerFormData.meansOfIdentificationIssueDate,
            )
            : null,
          meansOfIdentificationExpiryDate: this.individualCustomerFormData
            .meansOfIdentificationExpiryDate
            ? toYearWithDate(
              this.individualCustomerFormData.meansOfIdentificationExpiryDate,
            )
            : null,
        }
        const fullName = `${this.individualCustomerFormData?.lastName ?? ''} ${
          this.individualCustomerFormData?.firstName ?? ''
        } ${this.individualCustomerFormData?.otherNames ?? ''}`
        const response = this.actionType === 'save'
          ? await this.createIndividualCustomer(formData)
          : await this.updateIndividualCustomer(formData)
        const { status, data } = response

        if (status === 200) {
          const requestText = this.$t('Your request to')
          const profileText = this.$t('s profile with CustomerID')
          const successText = this.$t('was successful')
          if (this.actionType === 'save') {
            this.alertSuccess({
              text: `${requestText} ${action} ${fullName}${profileText}: ${data.customerID} ${successText}`,
            })
            this.$router.push({ name: 'individual-customer-information' })
          } else {
            this.alertSuccess({
              text: `${requestText} ${action} ${fullName}${profileText}: ${this.individualCustomerFormData.customerID} ${successText}`,
            })
            this.$router.push({ name: 'individual-customer-information' })
          }
        }
      } catch (error) {
        this.isLoading = false
        this.isDisabled = false
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const failedText = this.$t('Customer Information failed. Reason:')
          this.alertError({
            text: `${requestText} ${action} ${failedText} ${responseError.errorMessage}`,
          })
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    validateWorkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.workInfoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateNextOfKin() {
      return new Promise((resolve, reject) => {
        this.$refs.nextOfKinRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validatUploads() {
      return new Promise((resolve, reject) => {
        this.$refs.uploadRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    bvnValidateAction() {
      if (this.individualCustomerFormData.bvn) {
        this.confirm(this.validateBVNAction, {
          text: this.$t(
            'BVN validation comes at a cost to the bank!  Are you sure you want to proceed?',
          ),
        })
      } else {
        this.alertError({ text: this.$t('BVN field is empty') })
      }
    },

    async validateBVNAction() {
      try {
        this.isLoading = true
        this.showSpinner = true
        const formData = {
          bvnNumber: this.individualCustomerFormData.bvn,
        }
        const response = await this.validateBVN({
          formData,
          permission: accountPermissions.VALIDATE_BVN,
        })
        const { data, status } = response
        if (status === 200 && data.result) {
          this.bvnInformationDetails = {
            ...data.result,
            dateOfBirth: data.result.dateOfBirth
              ? toDateWithYear(data.result.dateOfBirth)
              : null,
            registrationDate: data.result.registrationDate
              ? toDateWithYear(data.result.registrationDate)
              : null,
          }
          this.showSpinner = false
          this.isLoading = false
          this.$root.$emit('bv::show::modal', 'bvn-validation-modal')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
        this.isLoading = false
      }
    },

    handleContinue() {
      this.isBVN = true
      this.individualCustomerFormData = {
        ...this.individualCustomerFormData,
        title: this.bvnInformationDetails.title,
        bvn: this.bvnInformationDetails.bvn,
        firstName: this.bvnInformationDetails.firstName,
        lastName: this.bvnInformationDetails.lastName,
        otherNames: this.bvnInformationDetails.middleName,
        address: this.bvnInformationDetails.residentialAddress,
        gender: this.bvnInformationDetails.gender,
        maritalStatus: this.bvnInformationDetails.maritalStatus,
        phoneNumber: this.bvnInformationDetails.phoneNumber1,
        notificationPhoneNumber: this.bvnInformationDetails.phoneNumber1,
        dateOfBirth: this.bvnInformationDetails.dateOfBirth,
        email: this.bvnInformationDetails.email,
        notificationEmail: this.bvnInformationDetails.email,
        nationality: this.bvnInformationDetails.nationality,
        state: this.bvnInformationDetails.stateOfOrigin,
        lga: this.bvnInformationDetails.lgaOfOrigin,
        hometown: this.bvnInformationDetails.lgaOfResidence,
      }
    },

    ninValidateAction() {
      if (this.individualCustomerFormData.nin) {
        this.confirm(this.validateNINAction, {
          text: this.$t(
            'NIN validation comes at a cost to the bank!  Are you sure you want to proceed?',
          ),
        })
      } else {
        this.alertError({ text: this.$t('NIN field is empty') })
      }
    },

    async validateNINAction() {
      try {
        this.isLoadingNIN = true
        this.showSpinner = true
        const formData = {
          nin: this.individualCustomerFormData.nin,
          requestChannel: 'CBA',
        }
        const response = await this.validateNIN({
          formData,
          permission: accountPermissions.VALIDATE_NIN,
        })
        const { data, status } = response
        if (status === 200 && data.result) {
          this.ninInformationDetails = {
            ...data.result,
            birthdate: data.result.birthdate
              ? dateSpecial(data.result.birthdate)
              : null,
            nin: this.individualCustomerFormData.nin,
          }
          this.showSpinner = false
          this.isLoadingNIN = false
          this.$root.$emit('bv::show::modal', 'nin-validation-modal')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
        this.isLoadingNIN = false
      }
    },

    handleNINContinue() {
      this.isNIN = true
      this.individualCustomerFormData = {
        ...this.individualCustomerFormData,
        title: this.ninInformationDetails.title,
        userID: this.ninInformationDetails.userID,
        firstName: this.ninInformationDetails.firstname,
        lastName: this.ninInformationDetails.surname,
        otherNames: this.ninInformationDetails.middlename,
        address: this.ninInformationDetails.residence_address,
        gender:
          this.ninInformationDetails.gender === 'M'
            ? this.$t('Male')
            : this.$t('Female'),
        maritalStatus: this.ninInformationDetails.maritalstatus,
        phoneNumber: this.ninInformationDetails.telephoneno,
        notificationPhoneNumber: this.ninInformationDetails.telephoneno,
        dateOfBirth: this.ninInformationDetails.birthdate,
        email: this.ninInformationDetails.email,
        notificationEmail: this.ninInformationDetails.email,
        nationality: this.ninInformationDetails.birthcountry,
        state: this.ninInformationDetails.birthstate,
        lga: this.ninInformationDetails.birthlga,
        hometown: this.ninInformationDetails.residence_town,
        nin: this.ninInformationDetails.nin,
        religion: this.ninInformationDetails.religion,
        nokName: `${this.ninInformationDetails.nok_surname} ${this.ninInformationDetails.nok_firstname} ${this.ninInformationDetails.nok_middlename}`,
        nokAddress: this.ninInformationDetails.nok_address1,
      }
    },

    async fetchIndividualCustomerDetails() {
      try {
        this.documentIdentifier = uuidv4()
        const { id } = this.$route.params
        if (id !== undefined) {
          this.showSpinner = true
          this.showBackButton = true
          this.actionType = 'edit'
          const response = await this.getIndividualCustomer({
            id,
            permission: accountPermissions.MODIFY_INDIVIDUAL_CUSTOMER,
          })
          this.$refs.individualCustomerForm.activateAll()
          const { data, status } = response
          if (status === 200 && data.data) {
            this.showSpinner = false
            this.individualCustomerFormData = {
              id: data.data.id,
              title: data.data.title,
              lastName: data.data.lastName,
              firstName: data.data.firstName,
              otherNames: data.data.otherNames,
              address: data.data.address,
              gender: data.data.gender,
              maritalStatus: data.data.maritalStatus,
              userID: data.data.userID,
              maidenName: data.data.maidenName,
              religion: data.data.religion,
              customerID: data.data.customerID,
              oldCustomerID: data.data.oldCustomerID,
              employeeID: data.data.employeeID,
              phoneNumber: data.data.phoneNumber,
              notificationPhoneNumber: data.data.notificationPhoneNumber,
              email: data.data.email,
              notificationEmail: data.data.notificationEmail,
              hometown: data.data.hometown,
              nationality: data.data.nationality === 'NGN' ? 'Nigeria' : data.data.nationality,
              state: data.data.state,
              lga: data.data.lga,
              bvn: data.data.bvn,
              nin: data.data.nin,
              meansOfIdentification: data.data.meansOfIdentification,
              idNumber: data.data.idNumber,
              meansOfIdentificationIssueDate: data.data
                .meansOfIdentificationIssueDate
                ? toDateWithYear(data.data.meansOfIdentificationIssueDate)
                : null,
              meansOfIdentificationExpiryDate: data.data
                .meansOfIdentificationExpiryDate
                ? toDateWithYear(data.data.meansOfIdentificationExpiryDate)
                : null,
              meansOfIdentificationPlaceOfIssue:
                data.data.meansOfIdentificationPlaceOfIssue,
              pep: data.data.pep,
              tin: data.data.tin,
              nokName: data.data.nokName,
              nokAddress: data.data.nokAddress,
              nokGender: data.data.nokGender,
              nokRelationship: data.data.nokRelationship,
              nokPhoneNumber: data.data.nokPhoneNumber,
              nokEmail: data.data.nokEmail,
              occupation: data.data.occupation,
              employerName: data.data.employerName,
              employerAddress: data.data.employerAddress,
              officePhoneNumber: data.data.officePhoneNumber,
              dateOfBirth: data.data.dateOfBirth
                ? toDateWithYear(data.data.dateOfBirth)
                : null,
            }

            this.documentIdentifier = data.data.documentIdentifier
              ? data.data.documentIdentifier
              : this.documentIdentifier
            this.documentsFormData = data.data.documents
              ? data.data.documents.map(item => ({
                url: item.url,
                type: item.typeID,
                fileName: item.type,
                id: item.id,
                fileExtension: item.fileExtension,
              }))
              : [
                {
                  url: '',
                  type: '',
                },
              ]
            this.datePickerConfig.defaultDate = toDateWithYear(
              data.data.dateOfBirth,
            )
            const nokRelationship = relationshipOptions.some(
              option => option.value === data.data.nokRelationship,
            )

            if (nokRelationship) {
              this.isOtherTypeOfRelationship = false
            } else if (!nokRelationship) {
              this.individualCustomerFormData.nokRelationship = ''
            } else {
              this.isOtherTypeOfRelationship = true
              this.individualCustomerFormData.nokRelationship = 'Others'
              this.typeOfRelationship = data.data.nokRelationship
            }
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'individual-customer-information',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-image {
  border: 2px dashed #dcd9d9;
  position: relative;
  width: 250px;
  height: 250px;
}
.format {
  color: #999999 !important;
}
form input[type="file"] {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.upload-instruction {
  padding-top: 22%;
  color: #000;
  text-align: center;
}
.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
.btn-text-right {
  text-align: right;
}

.validate-inline-field {
  position: relative;
}

.validation-field-input {
  padding-right: 100px;
}

.validation-action-btn {
  position: absolute;
  top: 23px;
  right: -2px;
  z-index: 2;
}
</style>
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/base/bootstrap-extended/_include.scss";
</style>
